export default __webpack_public_path__ + "static/media/Ocorrências (Real Size).61d4c283.svg";